import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import LoadingFade from "../../LoadingFade";
import {useState, useEffect, useRef, createRef } from "react";
import {useNavigate, useParams} from "react-router-dom";
import httpService from "../../../services/httpService";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Card from 'react-bootstrap/Card';
import Heading3 from "../../Heading3";
import SkillButton from "../SkillButton";
import Collapse from "react-bootstrap/Collapse";
import {FaRegTrashAlt} from "react-icons/fa";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import {Modal} from "react-bootstrap";

const newSkillTemplate = {
    "title" : "",
    "description" : ""
};
const StepSkills = ({onStageChange, onClubChange, podcastClub}) => {
    const { step, id } = useParams();
    const navigate = useNavigate();
    const [skillLoading, setSkillLoading] = useState(false);
    const [pageLoading, setPageLoading] = useState(true);
    const [isWizardCompleted, setIsWizardCompleted] = useState(false);
    const [hasSubscribedListeners, setHasSubscribedListeners] = useState(false);

    const [errorMessage, setErrorMessage] = useState('');
    const [clubSkills, setClubSkills] = useState([]);

    const [newSkill, setNewSkill] = useState(newSkillTemplate);
    const [newSkillErrors, setNewSkillErrors] = useState({});
    const [showVideoModal, setShowVideoModal] = useState(false);

    const nodeRefs = useRef({});

    useEffect(() => {
        loadSkills()
    }, [podcastClub]);

    const goToNextStep = () => {
        setPageLoading(true)
        onStageChange(3)
    };

    const goToClubDashboard = () => {
        setPageLoading(true)
        navigate(`/podcaster/podcast-club/${podcastClub.guid}`)
    };

    const handleAddSkill = async() => {
        setSkillLoading(true)
        const payload = {...newSkill};
        try {
            await httpService.post("dash/club/"+id+"/skills", payload);
            setNewSkill(newSkillTemplate)
            setNewSkillErrors({})
            loadSkills()
        } catch (err) {
            setErrorMessage(err.message)
            setNewSkillErrors({...err.response.data.errors})
        } finally {
            setSkillLoading(false)
            setPageLoading(false)
        }
    }

    const loadSkills = async() => {
        try {
            const res = await httpService.get("dash/club/"+id+"/skills");
            setClubSkills(res.data.skills)
            setPageLoading(false)
        } catch (err) {
            setErrorMessage(err.message)
        } finally {
            setPageLoading(false)
        }
    }

    const newSkillHandleChange = (e) => {
        setNewSkill({...newSkill, [e.target.name] : e.target.value})
    }

    return(
        <LoadingFade loading={pageLoading} stateKey={pageLoading?'loading':'not-loading'}>
            <Row className={'pb-3'}>
                <Col sm={12}>
                    <h4>What will listeners practise in this club?</h4>
                    <p>Add the skills listeners will actively practise through the episodes. &nbsp;<a onClick={() => setShowVideoModal(true)} className={"text-secondary collapse-info"} style={{cursor: 'pointer'}}>watch the video</a></p>
                </Col>
                <Col sm={12}>
                    <Card className={"p-3 pb-0"}>
                        <Row>
                            <Col sm={12} className={"d-flex flex-column justify-content-between"}>
                                <Form.Group className="" controlId="skillTitle">
                                    <Form.Label>Skill Name <span className="text-muted fw-normal">— What your listener will get sharper at by following the club. They see this when they join, and they tag it later when they actually try it out in their week.</span></Form.Label>
                                    <Form.Control
                                        name={'title'}
                                        value={newSkill.title}
                                        type="text"
                                        placeholder="Example: Confident decision-making"
                                        onChange={newSkillHandleChange}
                                        isInvalid={newSkillErrors.hasOwnProperty('title')}
                                        disabled={skillLoading}
                                        className={"mb-2"}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {newSkillErrors?.title ?? ""}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col sm={9}>
                                <Form.Group className="" controlId="skillDescription">
                                    <Form.Label>What does this skill involve? <span className="text-muted fw-normal">— What trying this skill out looks like in practice. The clearer this is, the easier it is for a listener to recognise the moment to tag, and for Podsy to spot the skill in your episodes.</span></Form.Label>
                                    <Form.Control
                                        value={newSkill.description}
                                        name={'description'}
                                        as="textarea"
                                        rows={3}
                                        type="text"
                                        placeholder="A short sentence describing how listeners will practise or apply this skill"
                                        onChange={newSkillHandleChange}
                                        isInvalid={newSkillErrors.hasOwnProperty('description')}
                                        disabled={skillLoading}
                                        className={"mb-2"}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {newSkillErrors.description ?? ""}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col sm={3} className={'d-flex align-items-end'}>
                                <div className={'w-100'}>
                                    <Form.Group className="" controlId="addSkill">
                                        <Form.Label>Add Skill</Form.Label>
                                        <Button disabled={skillLoading} onClick={() => handleAddSkill()} className={"d-block w-100"} variant="primary">
                                            Add Skill
                                        </Button>
                                    </Form.Group>
                                </div>
                            </Col>
                            <Col sm={12} className={"pt-3"}>
                                <TransitionGroup component={null}>
                                    {clubSkills.map((it) => {
                                        if (!nodeRefs.current[it.id]) nodeRefs.current[it.id] = createRef(); // <- use createRef
                                        const ref = nodeRefs.current[it.id];
                                        return(
                                            <CSSTransition
                                                key={it.id}
                                                timeout={250}
                                                classNames="skill"
                                                nodeRef={ref}   // <- important
                                            >
                                                <div ref={ref} className={'d-inline'}>
                                                    <SkillButton skill={it} onSkillAction={loadSkills} podcastClubGuid={id} />
                                                </div>
                                            </CSSTransition>
                                        )
                                    })}
                                </TransitionGroup>
                            </Col>
                        </Row>
                    </Card>
                </Col>
                <Col sm={12} className={'mt-3'}>
                    <Row>
                        <Col sm={4}>
                            <label className={'mb-2'}>Go to Title and Description</label>
                            <Button
                                variant={'light'}
                                className={'w-100'}
                                onClick={() => onStageChange(1, id)}>
                                Back
                            </Button>
                        </Col>
                        <Col sm={4}>
                            {isWizardCompleted ? (
                                <Button
                                    disabled={!(podcastClub?.title && podcastClub?.description)}
                                    variant={'primary'}
                                    className={'w-100'}
                                    onClick={goToClubDashboard}>
                                    Go to club dashboard
                                </Button>
                            ):''}
                        </Col>
                        <Col sm={4}>
                            <label className={'mb-2'}>Choose episodes for your Podcast Club</label>
                            <Button
                                disabled={!clubSkills.length}
                                variant={isWizardCompleted ? 'light' : 'primary'}
                                className={'w-100'}
                                onClick={goToNextStep}>
                                Continue
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>

            <Modal show={showVideoModal} onHide={() => setShowVideoModal(false)} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>What will listeners practise in this club?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{position: 'relative', paddingBottom: '56.25%', height: 0}}>
                        <iframe
                            src="https://www.loom.com/embed/bac725cc463a421ca55ca9df3adecbbb"
                            frameBorder="0"
                            webkitallowfullscreen="true"
                            mozallowfullscreen="true"
                            allowFullScreen
                            style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%'}}
                        />
                    </div>
                </Modal.Body>
            </Modal>
        </LoadingFade>
    )
}

export default StepSkills;